import React from "react";
import { Box, Toolbar, useTheme } from "@mui/material";

export const StepScreen = ({ name, activeStep, children, actions }) => {
  const theme = useTheme();

  return (
    <Box
      className={`step ${activeStep === name ? "active" : ""}`}
      sx={{
        height: "100%",
        backgroundColor:
          activeStep === "home"
            ? theme.palette.blueGray50.main
            : theme.palette.blueGray500.main,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Toolbar />
      <Box sx={{ flex: 1, overflowY: "auto" }}>{children}</Box>
      {actions && <>{actions}</>}
    </Box>
  );
};
